export default __webpack_public_path__ + "static/media/dragndrop.881e8cf0.svg";